import React, { useState, Fragment } from "react";
import '../Holidays/Holidays.css';
import { nanoid } from "nanoid";
import data from "../Holidays/mock-data.json";
import ReadOnlyRow from "../Holidays/ReadOnlyRow";
import EditableRow from "../Holidays/EditableRow";


const UserManagment = () => {
    const [contacts, setContacts] = useState(data);
    const [addFormData, setAddFormData] = useState({
        namee: "",
        date: "",
        day: ""

    });
    const [editFormData, setEditFormData] = useState({
        namee: "",
        date: "",
        day: ""

    });
    const [editContactId, setEditContactId] = useState(null);

    const handleAddFormChange = (event) => {
        event.preventDefault();

        const fieldName = event.target.getAttribute("name");
        const fieldValue = event.target.value;

        const newFormData = { ...addFormData };
        newFormData[fieldName] = fieldValue;

        setAddFormData(newFormData);
    };
    const handleEditFormChange = (event) => {
        event.preventDefault();

        const fieldName = event.target.getAttribute("name");
        const fieldValue = event.target.value;

        const newFormData = { ...editFormData };
        newFormData[fieldName] = fieldValue;

        setEditFormData(newFormData);
    };

    const handleAddFormSubmit = (event) => {
        event.preventDefault();
        const newContact = {
            id: nanoid(),
            namee: addFormData.namee,
            date: addFormData.date,
            day: addFormData.day,

        };
        const newContacts = [...contacts, newContact];

        setContacts(newContacts);
    };
    const handleEditFormSubmit = (event) => {
        event.preventDefault();

        const editedContact = {
            id: editContactId,
            namee: editFormData.namee,
            date: editFormData.date,
            day: editFormData.day,

        };

        const newContacts = [...contacts];

        const index = contacts.findIndex((contact) => contact.id === editContactId);

        newContacts[index] = editedContact;

        setContacts(newContacts);
        setEditContactId(null);
    };
    const handleEditClick = (event, contact) => {
        event.preventDefault();
        setEditContactId(contact.id);

        const formValues = {
            namee: contact.namee,
            date: contact.date,
            day: contact.day,

        };

        setEditFormData(formValues);
    };

    const handleCancelClick = () => {
        setEditContactId(null);
    };

    const handleDeleteClick = (contactId) => {
        const newContacts = [...contacts];

        const index = contacts.findIndex((contact) => contact.id === contactId);

        newContacts.splice(index, 1);

        setContacts(newContacts);
    };



    return (<div className="Holidays" id="Holidays">
        {/* <!-- Top Bar --> */}
        <div className="container-fluid1 py-2 icueTopBarContainer bg-white">
            <div className="row">
                <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="topBarLfContainer d-flex">
                        <div className="icueLogoContainer">
                            <img src="images/logo.png" alt="ICue Logo" className="icueLogo" />
                        </div>
                        <div className="icueSearchBox w-75 mx-3">
                            <div className="input-group ">
                                <span className="input-group-text" id="basic-addon1">
                                    <i className="bi bi-search"></i>
                                </span>
                                <input type="search" className="form-control icueSearchBoxControl" placeholder="Enter keywords..." aria-label="Username" aria-describedby="basic-addon1" />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="d-flex flex-row-reverse">
                        <div className="icueProfile px-2">
                            <img src="images/avatar.png" alt="icueProfilePic" className="icueProfilePic border border-dark rounded-circle" />
                        </div>
                        <div className="position-relative px-2">
                            <a href="#" id="icueNotifyBoxHandler">
                                <i className="bi bi-bell">
                                    <span className="position-absolute icueNofIndic"></span>
                                </i>
                            </a>
                            <div className="icueNotifyBox" id="icueNotifyBox">
                                Notifications
                            </div>
                        </div>

                        <div className="icueUserName fs-6 px-2">
                            Viral Patel
                        </div>

                        <div className="icueMail px-2">
                            <i className="bi bi-headset"></i> &nbsp;
                            adminhelpdesk@gmail.com
                        </div>
                    </div>
                </div>
            </div>
        </div>
        {/* <!-- /Top Bar -->

    <!-- Main Body --> */}
        <div className="container-fluid my-2">
            <div className="row">
                <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-12 col-sm-12 col-12 bg-white">
                    <div className="icueRespSideBar d-xxl-none d-xl-none d-lg-none d-md-block d-sm-block d-block" id="icueRespSideBar">
                        <button type="button" className="btn btn-primary" id="icueRespHumburger">
                            <i className="bi bi-grid-3x3-gap"></i>
                        </button>
                        <div className="icueSideBar" id="icueSideBar">
                            <nav className="navbar icueSideNavContainer">
                                <ul className="icueNavBarList">
                                    <li className="icueNavBarItem">
                                        <a href="/Hrdashboard" className="icueNavBarLink" id="">Dashboard</a>
                                    </li>
                                    <li className="icueNavBarItem border-bottom-0 active">
                                        <a href="#" className="icueNavBarLink" id="">User Management</a>
                                    </li>

                                    <li>
                                        <ul className="icueSubNavBar">
                                            <li className="icueSubNavItem">
                                                {/* <!-- <a href="#" data-bs-toggle="modal" data-bs-target="#addid" data-bs-whatever="@getbootstrap" className="icueSubNavLink  text-capitalize">Add Member</a> --> */}
                                                <a href="#" className="icueSubNavLink  text-capitalize">Add Members</a>
                                            </li>
                                            <li className="icueSubNavItem">
                                                <a href="/ListMembers" className="icueSubNavLink  text-capitalize">List of Members</a>
                                            </li>
                                        </ul>
                                    </li>
                                    <hr></hr>

                                    <li className="icueNavBarItem border-bottom-0">
                                        <a href="#" className="icueNavBarLink" id="">Leave Management</a>
                                    </li>

                                    <li>
                                        <ul className="icueSubNavBar">
                                            <li className="icueSubNavItem">
                                                {/* <!-- <a href="#" data-bs-toggle="modal" data-bs-target="#addid" data-bs-whatever="@getbootstrap" className="icueSubNavLink  text-capitalize">Add Member</a> --> */}
                                                <a href="/Leaves" className="icueSubNavLink  text-capitalize">Leaves</a>
                                            </li>
                                            <li className="icueSubNavItem">
                                                <a href="/LeaveType" className="icueSubNavLink  text-capitalize">Leave Type</a>
                                            </li>
                                        </ul>
                                    </li>
                                    <hr></hr>
                                    <li className="icueNavBarItem border-bottom-1 active">
                                        <a href="/Holidays" className="icueNavBarLink" id="">Holidays</a>
                                    </li>
                                    <li className="icueNavBarItem border-bottom-1">
                                        <a href="/Attendance" className="icueNavBarLink" id="">Attendance</a>
                                    </li>



                                    <li className="icueNavBarItem">
                                        <a href="/Department" className="icueNavBarLink" id="">Department</a>
                                    </li>

                                    <li className="icueNavBarItem">
                                        <a href="/AddRoles" className="icueNavBarLink" id="">Roles</a>
                                    </li>

                                    <li className="icueNavBarItem border-bottom-0">
                                        <a href="#" className="icueNavBarLink" id="">Payroll</a>
                                    </li>
                                    <li>
                                        <ul className="icueSubNavBar">
                                            <li className="icueSubNavItem">
                                                <a href="/EmpSalary" className="icueSubNavLink  text-capitalize">Employee Salary</a>
                                            </li>
                                            <li className="icueSubNavItem">
                                                <a href="/Payitems" className="icueSubNavLink  text-capitalize">Payroll Items</a>
                                            </li>
                                        </ul>
                                        <hr></hr>
                                    </li>

                                    <li className="icueNavBarItem border-bottom-0" style={{ marginTop: "-18px" }}>
                                        <a href="#" className="icueNavBarLink" id="">Settings</a>
                                    </li>
                                    <li>
                                        <ul className="icueSubNavBar">
                                            <li className="icueSubNavItem">
                                                <a href="#" className="icueSubNavLink  text-capitalize">Change Password</a>
                                            </li>
                                            <li className="icueSubNavItem">
                                                <a href="#" className="icueSubNavLink  text-capitalize">Profile</a>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>

                    <div className="icueNavSideBar d-xxl-block d-xl-block d-lg-block d-md-none d-sm-none d-none" id="icueNavSideBar">
                        <nav>
                            <ul className="icueNavBarList">
                                <li className="icueNavBarItem ">
                                    <a href="/Hrdashboard" className="icueNavBarLink" id="">Dashboard</a>
                                </li>

                                <li className="icueNavBarItem border-bottom-0 active">
                                    <a href="#" className="icueNavBarLink" id="">User Management</a>
                                </li>

                                <li>
                                    <ul className="icueSubNavBar">
                                        <li className="icueSubNavItem" style={{ marginTop: "-8px" }}>
                                            {/* <!-- <a href="#" data-bs-toggle="modal" data-bs-target="#addid" data-bs-whatever="@getbootstrap" className="icueSubNavLink  text-capitalize">Add Member</a> --> */}
                                            <a href="#" className="icueSubNavLink  text-capitalize">Add Member</a>
                                        </li>
                                        <li className="icueSubNavItem">
                                            <a href="/ListMembers" className="icueSubNavLink  text-capitalize">List of Members</a>
                                        </li>
                                    </ul>
                                </li>
                                <hr></hr>

                                <li className="icueNavBarItem border-bottom-0" style={{ marginTop: "-18px" }}>
                                    <a href="#" className="icueNavBarLink" id="" >Leave Management</a>
                                </li>

                                <li>
                                    <ul className="icueSubNavBar ">
                                        <li className="icueSubNavItem" style={{ marginTop: "-8px" }}>
                                            {/* <!-- <a href="#" data-bs-toggle="modal" data-bs-target="#addid" data-bs-whatever="@getbootstrap" className="icueSubNavLink  text-capitalize">Add Member</a> --> */}
                                            <a href="/Leaves" className="icueSubNavLink  text-capitalize">Leaves</a>
                                        </li>
                                        <li className="icueSubNavItem">
                                            <a href="/LeaveType" className="icueSubNavLink  text-capitalize">Leave Type</a>
                                        </li>
                                    </ul>
                                    <hr></hr>
                                </li>

                                <li className="icueNavBarItem " style={{ marginTop: "-18px" }}>
                                    <a href="/Holidays" className="icueNavBarLink" id="">Holidays</a>
                                </li>
                                <li className="icueNavBarItem ">
                                    <a href="/Attendance" className="icueNavBarLink" id="">Attendance</a>
                                </li>




                                <li className="icueNavBarItem" >
                                    <a href="/Department" className="icueNavBarLink" id="">Department</a>
                                </li>

                                <li className="icueNavBarItem">
                                    <a href="/AddRoles" className="icueNavBarLink" id="">Roles</a>
                                </li>


                                <li className="icueNavBarItem border-bottom-0">
                                    <a href="#" className="icueNavBarLink" id="">Payroll</a>
                                </li>
                                <li>
                                    <ul className="icueSubNavBar">
                                        <li className="icueSubNavItem">
                                            <a href="/EmpSalary" className="icueSubNavLink  text-capitalize">Employee Salary</a>
                                        </li>
                                        <li className="icueSubNavItem">
                                            <a href="/Payitems" className="icueSubNavLink  text-capitalize">Payroll Items</a>
                                        </li>
                                    </ul>
                                    <hr></hr>
                                </li>

                                <li className="icueNavBarItem border-bottom-0" style={{ marginTop: "-18px" }}>
                                    <a href="#" className="icueNavBarLink" id="">Settings</a>
                                </li>
                                <li>
                                    <ul className="icueSubNavBar">
                                        <li className="icueSubNavItem">
                                            <a href="#" className="icueSubNavLink  text-capitalize">Change Password</a>
                                        </li>
                                        <li className="icueSubNavItem">
                                            <a href="#" className="icueSubNavLink  text-capitalize">Profile</a>
                                        </li>
                                    </ul>
                                    <hr></hr>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>

            </div>
        </div>

    </div>)
}
export default UserManagment;